import React, { useMemo } from "react"
import { Box, Dialog, useTheme } from "@mui/material"
import { FeatureSummary } from "./Summary"
import { FeatureDetail } from "./Detail"

export const DesktopFeatureDialog = ({
  open,
  onClose,
  DirectionButtonProps = {},
  loading = true,
  data,
  onNavigate,
  isMultiOrdinalVenue,
  categoryIconProp = {},
  ...props
}) => {
  const theme = useTheme()
  const styleOverrides =
    theme.components[`AppDesktopFeatureDialog`]?.styleOverrides || {}
  const { dialog, contentContainer } = styleOverrides

  const {
    feature,
    zone,
    logo,
    category,
    level,
    name,
    hours,
    id,
    websiteLink,
    gallery,
    promotions,
    privileges,
    description,
    venueLogo,
    isNavigatable,
    canReserve,
    isNewShop,
    isComingSoon,
    isVatRefund,
    products,
    startDate,
    allLevels,
  } = data

  const allLevelDisplay = useMemo(
    () => allLevels?.join(", ") || "-",
    [allLevels]
  )

  return (
    <Dialog
      open={open}
      onClose={onClose}
      hideBackdrop
      disableEnforceFocus
      sx={dialog}
      {...props}
    >
      <Box sx={contentContainer}>
        <FeatureSummary
          id={id}
          name={name}
          hours={hours}
          level={level}
          category={category}
          logo={logo}
          venueLogo={venueLogo}
          zone={zone}
          onNavigate={onNavigate}
          DirectionButtonProps={DirectionButtonProps}
          loading={loading}
          categoryIconProp={categoryIconProp}
          isNavigatable={isNavigatable}
          canReserve={canReserve}
          isNewShop={isNewShop}
          isComingSoon={isComingSoon}
          isVatRefund={isVatRefund}
        />
        <FeatureDetail
          feature={feature}
          products={products}
          websiteLink={websiteLink}
          gallery={gallery}
          promotions={promotions}
          privileges={privileges}
          description={description}
          loading={loading}
          hours={hours}
          level={allLevelDisplay}
          category={category}
          isComingSoon={isComingSoon}
          startDate={startDate}
        />
      </Box>
    </Dialog>
  )
}
